module.exports = __webpack_public_path__ + "public/img/cm.df10811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/cm.jpg
// module id = 4xwN
// module chunks = 1